import React, {useEffect, useState} from 'react';
import {Line} from "@ant-design/plots";
import {API_PATH} from "../../components/const";

const PeakHours = () => {
    const [time, setTime] = useState(new Date());
    const [month, setMonth] = useState(time.getMonth());
    const [year, setYear] = useState(time.getFullYear());
    const [data, setData] = useState([]);
    // const dateFormat = 'YYYY-MM-DD';
    // function onChange(date, dateString) {
    //     if (dateString.length > 0){
    //         fetch(API_PATH + "company/" + localStorage.getItem('id') + "/analitics/hourly?date_str=" + Number(dateString.slice(0, 4)) +"-"+   Number(dateString.slice(5, 7)) + "-"+  Number(dateString.slice(8, 10)), {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
    //             .then((response) => response.json())
    //             .then((json) => setData(json?.map(item  =>{
    //                 return {
    //                     ...item,
    //                     date: item?.date?.slice(0, 5),
    //                 }
    //             })))
    //             .catch((error) => {
    //                 // console.log('fetch data failed', error);
    //             });
    //     }
    //     else (
    //         asyncFetch()
    //     )
    // }
    const asyncFetch = () => {
        fetch(API_PATH + "analytics/company/" + localStorage.getItem('id') + "/analytics/visitors/hourly-count?year=" + time?.getFullYear() + "&month=" + Number(time?.getMonth() + 1) + "&day=" +  Number(time?.getDate()) , {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then((response) => response.json())
            .then((json) => setData(json?.map(item  =>{
                return {
                    ...item,
                    date: item?.hour,
                    value: item?.count,
                    type: item?.type === "visitor" ? "Посетитель" : "Лид"
                }
            })))
            .catch((error) => {
            });
    };

    const config = {
        data,
        xField: 'date' ,
        seriesField: 'type',
        yField: 'value',
        legend: {
            position: 'top',
        },
        color:['#FC53F5', '#5664D2', '#00E480', '#FF3542', '#0090EB', '#FFB100', '#4D4F6C'],
        smooth: true,
        animation: {
            appear: {
                animation: 'path-in',
                duration: 5000,
            },
        },
    };

    useEffect(() => {
        asyncFetch();
    }, []);
    return (
        <div className="visitor visitor-box" style={{paddingRight: "0"}}>
            <div className="chart-box">

            <div className="visitor-title">
                <h1 ><span>
                   Часы пик
                </span>
                     {/*<DatePicker onChange={onChange}*/}
                     {/*            placeholder="Выберите дату"*/}
                     {/*            defaultValue={dayjs(time)}*/}
                     {/*/>*/}

                </h1>
            </div>
            <Line {...config} />
        </div>
        </div>
    );
};

export default PeakHours;